import { useEffect } from "react";
import { DragSourceMonitor } from "react-dnd";

const collect = (monitor: DragSourceMonitor) => ({
  isDragging: monitor.isDragging(),
});

const useDragHandler = (isDragging: boolean) => {
  useEffect(() => {
    if (isDragging) {
      document.body.classList.add("drag-in-progress");
    } else {
      document.body.classList.remove("drag-in-progress");
    }
  }, [isDragging]);
};

export { collect, useDragHandler };
